import request from '@/utils/request'

let Sign_typeApi = {

  /*签名分类列表*/
  list(data) {
    return request._post('/shop/plus.sign_type.Index/index', data);
},
/*添加签名分类*/
add(data) {
    return request._post('/shop/plus.sign_type.Index/add', data);
},
/*修改签名分类*/
edit(data) {
    return request._post('/shop/plus.sign_type.Index/edit', data);
},
/*删除签名分类*/
del(data) {
    return request._post('/shop/plus.sign_type.Index/del', data);
},
/*签名分类详情*/
detail(data) {
  return request._post('/shop/plus.sign_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.sign_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.sign_type.Setting/getSetting', data, errorback);
    },
}
export default Sign_typeApi;



// WEBPACK FOOTER //
// ./src/api/sign_type.js